module.exports = __webpack_public_path__ + "img/content15.ccab768d.png";